import { OPTION_CHAIN, OPTION_CHAIN_ERROR, OPTION_CHAIN_EXPIRY_DATE_DATA, OPTION_CHAIN_HIDE_ERROR, OPTION_CHAIN_START_LOADER, OPTION_CHAIN_STOP_LOADER, OPTION_CHAIN_STREAM, } from "../interface/iOptionChain";
import { optionChainStreamingUpdate } from "@domains/features/Markets/Options/utils/streamUpdate";
const initState = {
    data: {},
    loader: false,
    expiryDateList: {},
    errorData: {
        error: null,
        isOpen: false,
    },
};
const optionChain = (state = initState, action) => {
    switch (action.type) {
        case OPTION_CHAIN:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OPTION_CHAIN_STREAM:
            return Object.assign(Object.assign({}, state), { data: optionChainStreamingUpdate(state.data, action.payload.quoteStream) });
        case OPTION_CHAIN_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case OPTION_CHAIN_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case OPTION_CHAIN_EXPIRY_DATE_DATA:
            return Object.assign(Object.assign({}, state), { expiryDateList: action.payload.expiryDateList });
        case OPTION_CHAIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case OPTION_CHAIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default optionChain;
